import React, { useState, useEffect, useCallback } from 'react';
import { PageHeader, Page, PageMain } from "../../components/Page.jsx";
import Api from "../../api/Api.js";
import { useRecoilValue } from 'recoil';
import { userInfoState } from '../../data/UserInfo.jsx';

import PeriodButtonGroup from "./PeriodButtonGroup.jsx"
import TypeButtonGroup from "./TypeButtonGroup.jsx"
import FinishButtonGroup from "./FinishButtonGroup.jsx"
import CommentsDesc from "./CommentsDesc.jsx"

import DataTable from "./DataTable.jsx"
import { dataParser } from "./DataParser.js"
import * as XLSX from 'xlsx';

function buildHeaderRows(expanded) {
  if (expanded) {
    return [
      ['ID','접수일','수주번호','거래처','프로젝트명','총수량','예상매출액',
       '도장색상','도장두께','내진','기타',
       '구분','수량','등분','W','H','D','납기일','납품장소',
       ...['설계','P/G','제조1','제조2','제조3','출하','QC','AS'].flatMap(s =>
         [`${s}-시작일`,`${s}-종료일`,`${s}-담당자`,`${s}-작업시작`,`${s}-작업종료`,`${s}-비고`]
       )]
    ];
  }
  return [
    ['ID','수주번호','거래처','프로젝트명',
     '구분','수량','W','H','D','납기일',
     '설계','P/G','제조1','제조2','제조3','출하','QC','AS']
  ];
}

const Home = () =>{
  const userInfo = useRecoilValue(userInfoState);
  const [tasks, setTasks] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [periodMode, setPeriodMode] = useState(0);
  const [type, setType] = useState('');
  const [finishOnly, setFinishOnly] = useState(-1);

  useEffect(() => { reload(); }, [type, periodMode, finishOnly]);

  const reload = async ()=>{
    var ret = (await Api.taskScan(periodMode, type, finishOnly)).data;
    if (!ret["ret"]){
      return alert(ret["message"]);
    }
    setTasks(Array.isArray(ret.items) ? ret.items : []);
  }

  // Phase 1d: stable callbacks
  const handlePeriodClick = useCallback((pm) => setPeriodMode(pm), []);
  const handleTypeClick = useCallback((t) => setType(t), []);
  const handleFinishClick = useCallback((t) => setFinishOnly(t), []);
  const handleExpand = useCallback(() => setExpanded(prev => !prev), []);
  const handleYNClick = useCallback(() => {}, []);

  const onBGUpdate = useCallback((taskID, stepCode, bg) => {
    setTasks(prev => prev.map(project => {
      const hasDetail = project["details"]?.some(
        d => d["task_ID"] === taskID && d["step_code"] === stepCode
      );
      if (!hasDetail) return project;
      return {
        ...project,
        details: project["details"].map(d =>
          d["task_ID"] === taskID && d["step_code"] === stepCode
            ? { ...d, "비고": bg }
            : d
        )
      };
    }));
  }, []);

  const exportTableToExcel = useCallback(() => {
    const parsed = dataParser(expanded, tasks);
    if (parsed.length === 0) return;
    const maxRow = Math.max(...parsed.map(item => item[0]));
    const maxCol = Math.max(...parsed.map(item => item[1]));
    const grid = Array.from({ length: maxRow }, () => Array(maxCol).fill(''));
    parsed.forEach(([row, col, value]) => {
      grid[row - 1][col - 1] = value;
    });
    const headerRows = buildHeaderRows(expanded);
    const aoa = [...headerRows, ...grid];
    const ws = XLSX.utils.aoa_to_sheet(aoa);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, '작업현황');
    XLSX.writeFile(wb, '작업현황-.xlsx');
  }, [expanded, tasks]);

  return (
    <Page>
      <PageHeader>
        <div className="d-flex justify-content-between">
          <button className='btn btn-sm btn-outline-secondary' onClick={exportTableToExcel}>
            Export to Excel
          </button>
          <span>작업 현황 대쉬보드</span>
          <div></div>
        </div>
      </PageHeader>
      <PageMain style={{overflowX: "auto"}}>
        {userInfo["membertype"] > 1 ? <>
          <div className='d-flex justify-content-start'>
            <PeriodButtonGroup handleClick={handlePeriodClick} handleExpand={handleExpand} expanded={expanded} periodMode={periodMode}/>
            <div style={{width:"10px"}}></div>
            <TypeButtonGroup handleClick={handleTypeClick} type={type}/>
            <div style={{width:"10px"}}></div>
            <FinishButtonGroup handleClick={handleFinishClick} finishOnly={finishOnly}/>
            <CommentsDesc/>
          </div>

          <div className="mt-3" style={{width:expanded?"530rem":"100%"}}>
            {tasks.length === 0 ? (
              <span>Task가 없습니다.</span>
            ) : (
              <DataTable data2={tasks} expanded={expanded} handleYNClick={handleYNClick} onBGUpdate={onBGUpdate} />
            )}
          </div>
          </>
        :
          <div className="d-flex align-item-center justify-content-center">
            <div>
              <PeriodButtonGroup handleClick={reload} handleExpand={handleExpand} expanded={false}/>
              <TypeButtonGroup handleClick={reload}/>
              <div className="mt-3" style={{width:"100%"}}>
                <DataTable data2={tasks} expanded={false} />
              </div>
            </div>
          </div>
        }
      </PageMain>
    </Page>
  );

}


export default Home;
